import ActionIcon from './DesignSystem/ActionIcon'
import { Info } from './DesignSystem/Icons'
import Tooltip from './DesignSystem/Tooltip'

const InformationIcon = ({ tooltipText, id, containerStyle = {} }) => (
  <Tooltip text={tooltipText} id={`${id}_tooltip`}>
    <ActionIcon
      className="icon"
      id={`${id}_information_Icon`}
      containerStyle={containerStyle}
      Icon={Info}
      iconProps={{ width: '18px', height: '18px' }}
    />
  </Tooltip>
)

export default InformationIcon
